
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetPriorityRadarIec as ObiTargetPriorityRadarIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-priority-radar-iec.js';
 
 
 

 
 export const ObiTargetPriorityRadarIec = createComponent({
   react: React,
   tagName: 'obi-target-priority-radar-iec',
   elementClass: ObiTargetPriorityRadarIecElement,
   events: {
     
   }
  });
 
 